import { FunctionComponent, MouseEvent as ReactMouseEvent } from "react";

import { EmailIcon } from "@/components/EmailIcon/EmailIcon";

/**
 * The job-offer column's email badge: a copy button when there is an address to copy.
 *
 * A `RETRY` with no address has nothing to copy, so it renders as a plain indicator rather than a
 * button that would empty the clipboard and report "Copied to clipboard" (PREC-5035). The
 * `refresh` ("never searched") branch has always rendered the copy button and keeps doing so.
 */
export const OfferEmailStatusBadge: FunctionComponent<{
	email?: string | null;
	status: "retry" | "refresh";
	onCopy: (value: string) => void;
}> = ({ email, status, onCopy }) => {
	if (status === "retry" && !email) {
		return <EmailIcon status="retry" />;
	}

	return (
		<button
			aria-label="copy email"
			className="mr-1 cursor-pointer"
			type="button"
			onClick={(e: ReactMouseEvent) => {
				e.preventDefault();
				e.stopPropagation();
				onCopy(email ?? "");
			}}
		>
			<EmailIcon status={status} />
		</button>
	);
};
